<!-- <app-header></app-header> -->
<!-- <main class="main-section">
  <app-menu [items]="items"></app-menu>
</main> -->
<main class="main-section">
  <section
    class="main-container"
    style="margin-inline: 20%">
    <router-outlet></router-outlet>
  </section>
</main>
